import { call, takeEvery, put } from 'redux-saga/effects';
import {
    GET_SCHEDULES,
    CREATE_SCHEDULES,
    UPDATE_SCHEDULES,
    DELETE_SCHEDULES, GET_SCHEDULE_COMMANDS
} from "./actionTypes";
import {
    getSchedulesSuccess,
    dataError,
    setPagination,
    createSchedulesSuccess,
    createSchedulesFail,
    updateScheduleSuccess,
    updateScheduleFail,
    deleteScheduleSuccess, getScheduleCommandsSuccess
} from "./actions";

import {
    getSchedules,
    createSchedulesRequest,
    updateSchedulesRequest,
    deleteSchedulesRequest,
    getScheduleCommandsRequest
} from '../../library/http/backendHelpers'

function* fetchSchedules(params) {
    try {
        const response = yield call(getSchedules, params.filters);
        yield put(setPagination(response.meta))
        yield put(getSchedulesSuccess(response.data));
    }catch (error) {
        yield put(dataError(error))
    }
}

function* fetchScheduleCommands() {
    try {
        const response = yield call(getScheduleCommandsRequest);
        yield put(getScheduleCommandsSuccess(response.data));
    }catch (error) {
        yield put(dataError(error))
    }
}


function* createSchedule({ payload: schedule }) {
    try {
        const response = yield call(createSchedulesRequest, schedule);
        yield put(createSchedulesSuccess(response.data));
    }catch (error) {
        yield put(createSchedulesFail(error))
    }
}

function* editSchedule({payload: {schedule, schedule_id} }) {
    try {
        const response = yield call(updateSchedulesRequest, schedule, schedule_id);
        yield put(updateScheduleSuccess(response.data));
    }catch (error) {
        yield put(updateScheduleFail(error))
    }
}

function* deleteSchedule({ payload: {schedule_id}}) {
    try {
        const response = yield call(deleteSchedulesRequest, schedule_id);
        yield put(deleteScheduleSuccess(schedule_id));
    }catch (error) {
        yield put(dataError(error))
    }
}


function* scheduleSaga() {
    yield takeEvery(GET_SCHEDULES, fetchSchedules);
    yield takeEvery(GET_SCHEDULE_COMMANDS, fetchScheduleCommands);
    yield takeEvery(CREATE_SCHEDULES, createSchedule);
    yield takeEvery(UPDATE_SCHEDULES, editSchedule);
    yield takeEvery(DELETE_SCHEDULES, deleteSchedule);
}

export default scheduleSaga
